import React, { useContext } from 'react';
import { Flex, Box, Link, css } from 'theme-ui';
import ContentText from '@solid-ui-components/ContentText';
import Divider from '@solid-ui-components/Divider';
import ContentImages from '@solid-ui-components/ContentImages';
import ContentButtons from '@solid-ui-components/ContentButtons';
import QuickSignupForm from '@solid-ui-components/QuickSignupForm';
import WithDefaultContent from '@solid-ui-blocks/WithDefaultContent';
import { styles } from './styles';
import Icon from '@solid-ui-components/ContentIcon/ContentIcon';
import Modal, { ModalContext } from '@solid-ui-components/Modal';

const {
  wrapper,
  buttonsWrapper,
  imageContainer,
  button,
  buttonContainer,
  videoButtonContainer,
  videoButtonText,
  videoButtonTextContainer,
  topButtonsContainer,
  modal,
  iframe,
  imageWrapper,
} = styles;

const HeroBlock06 = ({
  content: { text, buttons, form, images, collection },
  omitVideo = false,
  imageStyles,
}) => {
  const { setActiveModal } = useContext(ModalContext);
  return (
    <Flex sx={wrapper}>
      <ContentText content={text.slice(0, 3)} />
      <Flex
        sx={{
          ...(images ? { marginBottom: '40px' } : {}),
          ...topButtonsContainer,
        }}
      >
        <Link
          href={buttons[0].link}
          sx={buttonContainer}
          target='_blank'
          rel='noreferrer'
        >
          <p css={css(button)}>{buttons[0].text}</p>
          <Icon content={collection[0].icon} size='xxs' mt={'5px'} />
        </Link>
        {omitVideo && <ContentButtons content={buttons.slice(1)} />}
      </Flex>
      {form && (
        <>
          <Divider space={4} />
          <QuickSignupForm {...form} space={3} />
        </>
      )}
      {images && (
        <>
          <Box sx={{ ...imageContainer, ...imageStyles }}>
            <ContentImages
              content={{ images: images.slice(0, 1) }}
              loading='eager'
              imagePosition='center'
            />
          </Box>
        </>
      )}
      {buttons[1] && !omitVideo && (
        <>
          <Flex sx={videoButtonContainer}>
            <Box
              sx={imageWrapper}
              onClick={() => setActiveModal(buttons[1].link)}
            >
              <ContentImages
                borderColor={'red'}
                content={{ images: images.slice(1) }}
              />
            </Box>
            <Flex sx={videoButtonTextContainer}>
              <p css={css(videoButtonText)}>{text[3].text}</p>
              <ContentButtons
                wrapperStyles={buttonsWrapper}
                content={buttons.slice(1)}
              />
            </Flex>
          </Flex>
          <Modal
            id={buttons[1].link}
            contentLabel='Video'
            contentStyles={modal}
          >
            <iframe
              style={iframe}
              src={buttons[1].link}
              title='Video'
              frameBorder='0'
              allow={
                'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
              }
              tabIndex='-1'
            />
          </Modal>
        </>
      )}
    </Flex>
  );
};

export default WithDefaultContent(HeroBlock06);
